// import './vendor';
// import './helpers';
// import './components/social';
// import {ieFix} from './vendor/ie-fix';
// import {vhFix} from './vendor/vh-fix';
// import {actualYear} from './modules/actualYear';
// import lazyBlure from './modules/lazyBlur';
// import header from './components/header';
// import scrollToAnchor from './modules/scrollToAnchor';
// import objectFitImages from 'object-fit-images';
import 'ninelines-ua-parser';
import index from './components/game/index';
import './components/social';
import analytics from './components/analytics';

window.onload = () => {
	index.init();
	analytics.init();
};

// ieFix();
// vhFix();
// actualYear();
// scrollToAnchor.init();

// header.init();
// lazyBlure.init();
